module.exports = __webpack_public_path__ + "img/shata_no.e167a222.png";